/* global graphql */

import React, { Component } from 'react';
import scrollToComponent from 'react-scroll-to-component'

import { highlights, betaCallout } from '../data/data'
import features from '../data/features'

import SCC from '../components/singleColContainer';
import Break from '../components/Break';
import Highlights from '../components/highlights';
import Features from '../components/features';
import Tsd from '../components/common/Tsd';
import MailChimpSignup from '../components/mailChimpSignup';

class IndexPage extends Component {
  render() {
    return (
      <main>
        {/* Main Header */}
        <div className='c-main-header'>
          <div className='container h-100 c-mw-xl'>
            <div className='row align-items-center h-100 my-5 my-md-0 py-5 py-md-0 '>
              <div className='col-12 col-md-6 col-lg-5 text-center text-md-left mb-5 mb-md-0'>
                <h1 className='c-medium mb-3'>
                  MajorKey 👌
                </h1>
                <h2 className='c-light mb-3'>
                  Get the most out of your keyboard.
                </h2>
                {/* This should have an action listener */}
                <button className='c-btn c-btn-cta mb-3' onClick={() => scrollToComponent(this.beta, { align: 'top' })}>
                  Download for Free
                </button>
              </div>
              <div className='col-12 col-md-6 col-lg-7'>
                <img src='/images/app-image.png' className='w-100 c-shadow-lg mb-5 mb-md-0' />
              </div>
            </div>
          </div>
        </div>

        <Highlights data={highlights} className='' />

        <Break />

        <Features data={features} className='' />

        <Break />

        <div ref={beta => this.beta = beta}>
          <Tsd {...betaCallout} className='mb-3 mb-md-5' />
        </div>
        {/* Call to Action */}
        {/* Subscription Sign UP */}
        {/* Footer */}
        <MailChimpSignup className='mb-3 mb-md-5 pb-3 pb-md-5' />
      </main>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js